import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Validate config
const isValidConfig = Object.values(firebaseConfig).every(
  (value) => value && value !== 'undefined' && value !== ''
);

if (!isValidConfig) {
  console.error('⚠️ Firebase configuration is incomplete. Check your .env file.');
}

// 1. Initialize Firebase FIRST
const app = initializeApp(firebaseConfig);

// 2. Enable App Check debug token in local dev (must run BEFORE initializeAppCheck)
if (import.meta.env.DEV) {
  // This exposes a debug token in the browser console so you can register it
  // in Firebase Console → App Check → Manage debug tokens.
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// 3. Initialize App Check with the v3 provider
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(
    import.meta.env.VITE_FIREBASE_RECAPTCHA_SITE_KEY
  ),
  isTokenAutoRefreshEnabled: true,
});

// 4. Initialize the other services
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);



export { app, db, storage, auth, appCheck };
export default app;